export default {"src":"/_next/static/image/public/images/SICCRO_Thumbnail.e5361b1b4b1e710d787d88ed0962ccb0.svg","height":300,"width":300};